/**
 * @file CustomImportMultiSelect.js
 * @description A multi-select dropdown component for selecting custom import templates.
 */

import React, { useState, useEffect } from "react";
import { SearchableDropdown } from "../../helpers/SearchableDropdown_style_b_v2";
import { getAllImportTemplatesForTenant } from "../../../services/importService";
import Toast from "../../ui/toasts/Toast";
import { getText } from '../../../i18n';

const CustomImportMultiSelect = ({
  className,
  selectedImportTemplates,
  onImportTemplatesChange,
  label = "Custom Import Templates",
  isRequired = false,
  resetTrigger,
  tenantId,
  showSelectedItemsInField = true,
  showSelectionBox = true,

  showSelectedCount = false,
}) => {
  const [importTemplates, setImportTemplates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadImportTemplates = async () => {
      try {
        setIsLoading(true);
        const data = await getAllImportTemplatesForTenant(tenantId);
        setImportTemplates(data);
      } catch (error) {
        console.error("Could not fetch custom import templates:", error);
        Toast.error(getText('msg_c3777f3ef732'));
      } finally {
        setIsLoading(false);
      }
    };

    loadImportTemplates();
  }, [tenantId]);

  const handleImportTemplatesChange = (selectedOptions) => {
    onImportTemplatesChange(selectedOptions);
  };

  return (
    <div className={`form-group mb-3 ${className}`}>
      <label htmlFor="custom-import-dropdown">
        {label}
        {isRequired && <span className="text-danger">*</span>}
      </label>
      <SearchableDropdown
        id="custom-import-dropdown"
        options={importTemplates}
        optionIDField="id"
        updateOptions={handleImportTemplatesChange}
        savedOptions={selectedImportTemplates}
        savedOptionIDField="id"
        disabled={importTemplates.length === 0}
        isLoading={isLoading}
        resetTrigger={resetTrigger}
        showSelectedItemsInField={showSelectedItemsInField}
        showSelectionBox={showSelectionBox}
        showSelectedCount={showSelectedCount}
        allSelectedLabel={getText('msg_fe1ac88341e3')}
      />
    </div>
  );
};

export default CustomImportMultiSelect;
